
export enum TimelineChartDataSource {
    REAL_TIME = 'real-time',
    SNAPSHOTS = 'snapshots',
}

export const TIMELINE_CHART_DATA_SOURCE_OPTIONS = [
    { value: TimelineChartDataSource.REAL_TIME, label: 'Real-time (field-based)' },
    { value: TimelineChartDataSource.SNAPSHOTS, label: 'Historical (snapshots)' },
]